import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { FadeUp } from "@/components/Reveal";
import { useLang } from "@/lib/i18n";

export default function CTABand() {
  const { lang } = useLang();
  const zh = lang === "zh";
  return (
    <section className="bg-[#ffde00] py-20 md:py-28" data-testid="cta-band">
      <div className="max-w-[1800px] mx-auto px-4 md:px-8 flex flex-col md:flex-row items-start md:items-center justify-between gap-8">
        <FadeUp>
          <div className="font-mono2 text-xs text-black/60 tracking-[0.3em] mb-4">{zh ? "LET'S WORK TOGETHER" : "LET'S WORK TOGETHER"}</div>
          <h2 className="font-display text-4xl md:text-6xl uppercase leading-[0.95] text-black">
            {zh ? (
              <>
                有一个舞台
                <br />
                想要点亮？
              </>
            ) : (
              <>
                Got a stage
                <br />
                to light up?
              </>
            )}
          </h2>
        </FadeUp>
        <FadeUp delay={0.15}>
          <Link
            to="/contact"
            data-testid="cta-band-button"
            className="inline-flex items-center gap-2 bg-black text-[#ffde00] font-bold text-sm tracking-[0.15em] uppercase px-10 py-5 border border-black hover:bg-transparent hover:text-black transition-colors duration-300"
          >
            {zh ? "开始洽谈" : "START A CONVERSATION"}
            <ArrowRight size={16} />
          </Link>
        </FadeUp>
      </div>
    </section>
  );
}
